// src/icons/svgs/code.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgCode = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 28, fill: "none", viewBox: "0 0 28 28", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "#343A40", fillRule: "evenodd", d: "M10.48 23.941a.77.77 0 0 0 .548.948.787.787 0 0 0 .957-.553l5.54-20.251a.77.77 0 0 0-.547-.948.787.787 0 0 0-.958.553zm8.898-16.095a.78.78 0 0 1 1.1-.011l5.731 5.623a.78.78 0 0 1 0 1.11l-5.732 5.623a.778.778 0 1 1-1.089-1.11l5.166-5.068-5.166-5.068a.78.78 0 0 1-.01-1.1m-10.75 0c.301.307.296.8-.01 1.1l-5.173 5.067 5.172 5.067A.778.778 0 1 1 7.53 20.19l-5.74-5.622a.78.78 0 0 1 0-1.112l5.74-5.622c.307-.3.799-.296 1.1.011", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgCode);
var code_default = ForwardRef;
export {
  code_default as Code
};
